import { jsx as _jsx } from "react/jsx-runtime";
const SoundCloudEmbed = ({ link }) => {
    return (_jsx("iframe", { width: "100%", height: "166", scrolling: "no", allow: "autoplay", src: `https://w.soundcloud.com/player/?url=${link}` }));
};
export default SoundCloudEmbed;
